export default "__VITE_ASSET__CfE_m5C___"